import React from 'react';
import * as ReactDOM from 'react-dom';
import { Button, InputItem, Toast, Icon } from 'antd-mobile';
import { createForm } from 'rc-form';
import {post} from '../../utils/request';
import { getUrlParam, href } from '../../utils/util';
import api from './api';

import './index.less';

const NUM_SECTIONS = 10;
const NUM_ROWS_PER_SECTION = 10;
let pageIndex = 0;

let dataBlobs = {};
let sectionIDs = [];
let rowIDs = [];

class BindBank extends React.Component {
    constructor(...args) {
        super(...args);

        this.state = {
            tabName: 1,
            isLoading: true,
            hasMore: true,
            height: document.documentElement.clientHeight * 10 / 4,
            data: [],
            skipCount: 0,
            pageSize: 10,
            value: null,
            customerName: '',
            accountBankName: '',
            accountBankCode: '',
            bankAccount: '',
            hcAccountBankInfoId: ''
        };
    }

    componentDidMount() {
    }

    componentWillMount() {
        this.init()
    }

    init(){
        sectionIDs = [];
        rowIDs = [];
        dataBlobs = {};
        pageIndex = 0;
        this.setState({accountBankName: getUrlParam('accountBankName'),accountBankCode: getUrlParam('accountBankCode'),customerName: getUrlParam('customerName'),bankAccount: getUrlParam('bankAccount'),hcAccountBankInfoId: getUrlParam('hcAccountBankInfoId')})
    }

    submit = () => {
        const {customerName,accountBankName,accountBankCode,bankAccount,hcAccountBankInfoId} = this.state
          if(!customerName){
            Toast.info('姓名不能为空',1);
            return
          };
          if(!accountBankName){
            Toast.info('开户行不能为空',1);
            return
          };
          if(!bankAccount){
            Toast.info('银行账号不能为空',1);
            return
          };
          if(13>bankAccount.length){
            Toast.info('银行账号长度为13-19位',1);
            return
          }
          post({
            url: api.createBankInfo+'?app_stoken=' + getUrlParam('app_stoken') + '&activity=365',
            data:{
                customerName,
                accountBankName,
                accountBankCode,
                bankAccount,
                hcAccountBankInfoId
            }
          }).then((res) => {
              if(res.result === 'success'){
               Toast.info('绑定成功！', 1)
               href(`/withdrawal?app_stoken=${getUrlParam('app_stoken')}&activityCode=${getUrlParam('activityCode')}&tabName=2`)
              }else{
                Toast.info('绑定失败', 1)
              }
          }, (res)=>{
              Toast.info('绑定失败', res)
          });
      }

    render() {
        const onFinish = (values) => {
            // Dialog.alert({
            //   content: <pre>{JSON.stringify(values, null, 2)}</pre>,
            // })
          }

          const { getFieldProps } = this.props.form;
        
        return (
            <div className={'bg'}>
            <div className={'form'}>
                <div className='inputContent'>
                    <span>姓名</span>
                    <InputItem
                    placeholder="请输入本人的真实姓名"
                    value={this.state.customerName}
                    onChange={(val)=>{this.setState({customerName: val})}}
                    >
                    </InputItem>
                </div>
         
                <div className='inputContent'>
                    <span>开户行</span>
                    <a onClick={
                        ()=>{
                            href(`/selectBank?app_stoken=${getUrlParam('app_stoken')}&customerName=${this.state.customerName}&bankAccount=${this.state.bankAccount}&hcAccountBankInfoId=${this.state.hcAccountBankInfoId}&activityCode=${getUrlParam('activityCode')}`)
                        }
                    }>
                        <InputItem 
                            style={{ paddingRight: '0.32rem', color: '#000' }}
                            value={this.state.accountBankName}
                            placeholder="请选择银行开户网点"
                            disabled
                        >
                            <Icon type='search' style={{ width: '0.16rem', height: '0.16rem', position: 'absolute', right: '0.08rem', top: '0.26rem' }} />
                        </InputItem>
                    </a>
                </div>
          
                <div className='inputContent'>
                    <span>银行账号</span>
                    <InputItem
                        type='bankCard'
                        maxLength={23}
                        placeholder="请输入本人的银行卡号"
                        value={this.state.bankAccount}
                        onChange={(val)=>{this.setState({bankAccount: val})}}
                    >
                    </InputItem>
                </div>
            </div>
        <Button className='button' onClick={this.submit}>立即绑定</Button>

      </div>
        );
    }
}
export default createForm()(BindBank);


// WEBPACK FOOTER //
// ./src/bindBank/index/index.js